import React, { FC, useEffect } from 'react'
import { useTranslation } from '../../utils/convergence'
import { isNullOrUndefined } from '@afterpay/utils'
import styles from './styles.module.css'
import { useThemePerClass } from '@afterpaytouch/core'
import DOMPurify from 'dompurify'

interface PpaIframeProps {
  ppa?: string
  isPaymentAuth: boolean
  isPpaError: boolean
}

export const PPAIframe: FC<PpaIframeProps> = ({ ppa, isPaymentAuth, isPpaError }) => {
  const { t } = useTranslation()
  const themeClass = useThemePerClass(styles)

  useEffect(() => {
    if (!isPpaError) {
      const ppaIframe: HTMLIFrameElement | null = document.querySelector('#ppa-list')

      const scrollToPayAuth = (): void => {
        if (isNullOrUndefined(ppaIframe) || isNullOrUndefined(ppaIframe.contentWindow)) {
          return
        }
        ppaIframe.contentWindow.location.hash = 'payment-authorization'
      }

      if (isPaymentAuth) {
        ppaIframe?.addEventListener('load', scrollToPayAuth)
      }

      return () => {
        ppaIframe?.removeEventListener('load', scrollToPayAuth)
      }
    }
  }, [isPaymentAuth])

  return (
    <>
      {isPpaError ? (
        <iframe
          id='ppa-list-error'
          data-testid='ppa-iframe-list-error'
          title='ppa-error'
          className={themeClass.ppaIframe}
          src={t('common:termsOfServiceUrl')}
        ></iframe>
      ) : (
        <iframe
          data-testid='ppa-iframe-list'
          id='ppa-list'
          className={themeClass.ppaIframe}
          title={t('common:iframeTitlePurchasePaymentAgreement')}
          srcDoc={DOMPurify.sanitize(ppa ?? '', {
            ADD_TAGS: ['style', 'link', 'meta', 'script'], // Allow style tags which might be needed for PPA formatting
            ADD_ATTR: ['charset', 'name', 'content', 'http-equiv', 'property', 'itemprop'], // Allow common meta tag attributes
            FORCE_BODY: true, // Ensure output has html and body tags
          })}
        ></iframe>
      )}
    </>
  )
}
